module.exports = __webpack_public_path__ + "index/img/icon_zhifubao.34cd34db.svg";